
import React, { useEffect, useRef, useState } from "react";
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// import styles from './Map.module.css'

const Map = ({ centers = [], coaches = [], stateFilter, mapViewType }) => {

    const mapContainer = useRef(null)
    const map = useRef(null)


    const getCoordinates = () => {
        switch (stateFilter) {
            case 'VIC':
                return [144.96768376067078, -37.81218275713726]
            case 'QLD':
                return [152.96913883661793, -27.33038818340704]
            case 'NSW':
                return [150.9343988538486, -33.86860913799084]
            case 'WA':
                return [115.78309445236395, -31.954388523364543]
            case 'TAS':
                return [147.1, -42.0]
            default:
                return [144.96768376067078, -37.81218275713726]
        }
    }

    useEffect(() => {
        mapboxgl.accessToken = 'pk.eyJ1IjoiYnJ2aXNobnU5MiIsImEiOiJjbGltemhoeHcwMXJwM2NwYTZheTJnanJqIn0.R1OW0UWPqpDnAoeZl29Vmg'
        map.current = null
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/light-v10',
            center: [143.92800809602485, -37.25537959029776],
            // dragPan: false,
            // doubleClickZoom: false,
            scrollZoom: false,
            zoom: 6,
        })

        // console.log('centers', centers.filter(r => r.addressGeo))

        map.current.on('load', () => {

            if (mapViewType != 'Coaches') {
                // Centers
                map.current.loadImage('https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRLbuV3u2jZdal-lGSn1rB_PKGGKk3xf24FCPvPro_xyQur05H21gHtXWYNBNdZzCdsEYk&usqp=CAU',
                    (error, image) => {
                        if (error) throw error;
                        map.current.addImage('center-marker', image)
                        // Add a GeoJSON source with 2 points

                        const centerData = {
                            'type': 'FeatureCollection',
                            'features': centers.filter(r => r.addressGeo).map(row => ({
                                'type': 'Feature',
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': [row.addressGeo.lng, row.addressGeo.lat]
                                },
                                'properties': {
                                    'title': row.name
                                }
                            }))
                        }

                        if (map.current.getSource('centers')) {
                            map.current.getSource('centers').setData(centerData)
                        } else {
                            map.current.addSource('centers', {
                                'type': 'geojson',
                                'data': centerData
                            })
                        }

                        // Add a symbol layer
                        map.current.addLayer({
                            'id': 'centers',
                            'type': 'symbol',
                            'source': 'centers',
                            // 'paint': {
                            //     'text-opacity': 0,
                            // },
                            'layout': {
                                'icon-image': 'center-marker',
                                'icon-size': 0.10,
                                'icon-allow-overlap': true,
                                // get the title name from the source's "title" property
                                'text-field': ['get', 'title'],
                                'text-font': [
                                    'Open Sans Semibold',
                                    'Arial Unicode MS Bold'
                                ],
                                'text-optional': true,
                                'text-offset': [0, 1.25],
                                'text-anchor': 'top',
                                'text-size': 10,
                            }
                        })
                    }
                )
            }
            if (mapViewType !== 'Centers') {
                // Coaches
                map.current.loadImage('https://docs.mapbox.com/mapbox-gl-js/assets/custom_marker.png',
                    (error, image) => {
                        if (error) throw error;
                        map.current.addImage('coaches-marker', image)
                        // Add a GeoJSON source with 2 points

                        const coachData = {
                            'type': 'FeatureCollection',
                            'features': coaches.filter(r => r.status === 'Active' && r.addressGeo).map(row => ({
                                'type': 'Feature',
                                'geometry': {
                                    'type': 'Point',
                                    'coordinates': [row.addressGeo.lng, row.addressGeo.lat]
                                },
                                'properties': {
                                    'title': row.firstName + ' ' + row.lastName
                                }
                            }))
                        }

                        if (map.current.getSource('coaches')) {
                            map.current.getSource('coaches').setData(coachData)
                        } else {
                            map.current.addSource('coaches', {
                                'type': 'geojson',
                                'data': coachData
                            })
                        }

                        // Add a symbol layer
                        map.current.addLayer({
                            'id': 'coaches-labels',
                            'type': 'symbol',
                            'source': 'coaches',
                            // 'paint': {
                            //     'text-opacity': 0,
                            // },
                            'layout': {
                                'icon-image': 'coaches-marker',
                                'icon-size': 0.6,
                                'icon-allow-overlap': true,
                                // get the title name from the source's "title" property
                                'text-field': ['get', 'title'],
                                'text-font': [
                                    'Open Sans Semibold',
                                    'Arial Unicode MS Bold'
                                ],
                                'text-optional': true,
                                'text-offset': [0, 1.25],
                                'text-anchor': 'top',
                                'text-size': 10,
                            }
                        })
                    }
                )
            }
            
            if (stateFilter !== 'All') {

                map.current.flyTo({
                    center: getCoordinates(),
                    // essential: true // this animation is considered essential with respect to prefers-reduced-motion
                });
            }
            map.current.addControl(new mapboxgl.NavigationControl())
        })

    }, [centers, coaches])

    return (
        <div style={{ position: 'fixed', top: '300px', left: 0, right: 0, bottom: 0 }}>

            <div className={{
                width: 'calc(100% - 300px)',
                height: '800px'
            }} ref={mapContainer} />
        </div>
    )
}

export default Map;

